export default __webpack_public_path__ + "media/images/client-logos/docusign-cee8f79a1800ea55a1e91ad09f4c342a.png";